import Vue from 'vue'
import App from './App.vue'

import router from '@/modules/router'
import store from '@/modules/store'
import '@/modules/vendors'
import '@/modules/mixins'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  const isAdmin = store.getters["auth/isAdmin"];
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

  if (requiresAuth && !isAuthenticated) {
    next('/sign-in');
  } else if (requiresAdmin && !isAdmin) {
    next('/');
  } else {
    next();
  }
});

store.dispatch('auth/authenticate')
.catch(() => {}).then(() => {
	new Vue({
		render: h => h(App),
		router,
		store
	}).$mount('#app')
});
